
import currencyResult from './data/currencyResult'
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))
let shouldReject = false

export default {
  getCurrencies () {
    console.info('** getCurrencies mock **')
    return new Promise((resolve, reject) => {
      delay(1000).then(() => {
        if (shouldReject) {
          console.error('rejected', reject)
        } else {
          return resolve(currencyResult)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/mock/currencyMockApi.js